import { defineMessages } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { CommonPreferences } from '@sorare/core/src/components/settings/CommonPreferences';
import { Currency } from '@sorare/core/src/components/settings/Currency';
import { Disable3D } from '@sorare/core/src/components/settings/Disable3D';
import { PreferredLanguage } from '@sorare/core/src/components/settings/PreferredLanguage';
import { SettingsSection } from '@sorare/core/src/components/settings/SettingsSection';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

import { SettingsWrapper } from 'components/settings/SettingsWrapper';

const messages = defineMessages({
  title: {
    id: 'globalPreferences.lightMode',
    defaultMessage: 'Accessibility mode',
  },
  description: {
    id: 'globalPreferences.lightMode.description',
    defaultMessage:
      'Enable this experimental feature if you have difficulties reading white text on black background',
  },
});

const ExperimentalDarkMode = () => {
  const { lifecycle, update } = useLifecycle();
  const {
    flags: { useLightMode },
  } = useFeatureFlags();
  if (!useLightMode) {
    return null;
  }
  const lightMode = lifecycle?.[LIFECYCLE.experimentalLightMode];
  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={lightMode}
          onChange={() => {
            update(LIFECYCLE.experimentalLightMode, !lightMode);
          }}
        />
      }
    />
  );
};

export const GlobalPreferences = () => {
  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.GLOBAL_PREFERENCES]}>
      <Vertical gap={2}>
        <Currency />
        <PreferredLanguage />
        <Disable3D />
        <CommonPreferences />
        <ExperimentalDarkMode />
      </Vertical>
    </SettingsWrapper>
  );
};

export default GlobalPreferences;
